export const ACTION_RESET = 'FETCH_INDEXPAGELIST_RESET';
export const ACTION_REQUEST = 'FETCH_INDEXPAGELIST_REQUEST';
export const ACTION_SUCCESS = 'FETCH_INDEXPAGELIST_SUCCESS';
export const ACTION_ERROR = 'FETCH_INDEXPAGELIST_ERROR';
